import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Select from 'react-select'
import * as _ from 'lodash'
import Loading from './widgets/Loading'
import {
    ACCOUNT_CREATE_PAGE_LOADED,
    ACCOUNT_CREATE,
    ACCOUNT_CREATE_PAGE_UNLOADED
} from '../constants/actionTypes';
import { Countries } from '../constants/config'

const mapStateToProps = state => ({
    ...state.account,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
    countries: state.common.countries,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: ACCOUNT_CREATE_PAGE_LOADED, payload }),
    onSubmit: (payload, userkey) => {
        dispatch({ type: ACCOUNT_CREATE, payload, userkey })
    },
    onUnload: () =>
        dispatch({ type: ACCOUNT_CREATE_PAGE_UNLOADED })
});

class UserAccountAdd extends React.Component {
    constructor() {
        super();
        this.state = {
            symbols: ''
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = () => ev => {
            ev.preventDefault();
            const userkey = this.props.match.params.key
            const symbols = this.state.symbols
            const payload = agent.Accounts.createAccounts(userkey, symbols);
            this.props.onSubmit(payload, userkey);
        }
    }
    componentWillMount(props) {
        if (this.props.currentUser) {
            const userkey = this.props.match.params.key
            const payload = agent.Accounts.user(userkey)
            this.props.onLoad(payload);
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.accounts) {
            return (
                <Loading />
            )
        }
        const userkey = this.props.match.params.key
        const inProgress = this.props.inProgress
        const countries = this.props.countries || Countries
        const symbols = countries.map(i => i.symbol)
        const existingSymbols = this.props.accounts.map(i => i.symbol)
        const availableSymbols = _.filter(symbols, i => existingSymbols.indexOf(i) < 0);
        const symbolOptions = availableSymbols.map(i => { return { value: i, label: i } })
        return (
            <div className='pane' style={{minHeight:'600px'}}>
                <Link className="crumb" to={`/users/${userkey}`}>&laquo; back to user</Link>
                <h1>Add accounts</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm()}>
                    <fieldset className="form">
                        <strong>Symbols</strong>
                        <fieldset className="form-group">
                            <div style={{ maxWidth: '300px' }}> <Select
                                closeMenuOnSelect={false}
                                // defaultValue={[symbolOptions[0]]}
                                isMulti
                                options={symbolOptions}
                                onChange={(selectedOptions) => {
                                    console.log(selectedOptions)
                                    console.log(selectedOptions.map(i => i.value).join(','))
                                    this.setState({ symbols: selectedOptions ? selectedOptions.map(i => i.value).join(',') : '' })
                                }}
                            // className="basic-multi-select"
                            // classNamePrefix="select"
                            />
                            </div>
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Create accounts
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAccountAdd);



// WEBPACK FOOTER //
// ./src/components/UserAccountAdd.js